// Static config for the Task module. All real data (tasks, labels, fields,
// users, teams, customers, events) is fetched from the backend.

export const STATUS_LIST = [
  { value: 'TODO', label: 'Cần làm', color: '#6b7280' },
  { value: 'DOING', label: 'Đang làm', color: '#2563eb' },
  { value: 'REVIEW', label: 'Chờ duyệt', color: '#d97706' },
  { value: 'DONE', label: 'Hoàn thành', color: '#16a34a' },
];

export const PRIORITY_LIST = [
  { value: 'high', label: 'Cao', icon: '!', color: '#dc2626' },
  { value: 'mid', label: 'Trung bình', icon: '=', color: '#d97706' },
  { value: 'low', label: 'Thấp', icon: '↓', color: '#16a34a' },
];

// Five canonical task custom field types (matches Customer side):
//   Text / Number / Date / SingleSelect / MultiSelect
// Stored as Backend dataType uppercase: TEXT / NUMBER / DATE /
// SINGLE_SELECT / MULTI_SELECT. The `value` here is what the UI keeps in
// memory (lowercase form taken from dataType.toLowerCase()).
export const FIELD_TYPES = [
  { value: 'text',         label: 'Văn bản' },
  { value: 'number',       label: 'Số' },
  { value: 'date',         label: 'Ngày' },
  { value: 'singleselect', label: 'Lựa chọn đơn' },
  { value: 'multiselect',  label: 'Lựa chọn nhiều' },
];

export const LABEL_PALETTE = [
  '#dc2626', '#ea580c', '#d97706', '#ca8a04',
  '#16a34a', '#0d9488', '#0e7490', '#2563eb',
  '#7c3aed', '#be185d', '#6b7280', '#111827',
];

const _INITIAL_PALETTE = ['#5b4bbd', '#0d9488', '#d97706', '#be185d', '#2563eb', '#7c3aed', '#0e7490', '#dc2626'];

export function findStatus(value) {
  return STATUS_LIST.find((s) => s.value === value);
}

export function findPriority(value) {
  return PRIORITY_LIST.find((p) => p.value === value);
}

// Tenant usernames are formatted as "companyCode/username" — avatar
// initials take the first two characters AFTER the slash. Older data may
// still use "companyCode_username" with an underscore separator, so we
// accept either. Usernames with neither separator fall back to the first
// two chars of the whole string. Result is always 2 upper-case letters
// (or '?' when name is empty).
export function userInitials(name) {
  if (!name) return '?';
  const trimmed = String(name).trim();
  if (!trimmed) return '?';
  // Find the LAST separator so codes like "AAA/BBB/user" still pick "user".
  let sep = trimmed.lastIndexOf('/');
  if (sep < 0) sep = trimmed.lastIndexOf('_');
  const body = sep >= 0 ? trimmed.substring(sep + 1) : trimmed;
  if (!body) return trimmed.substring(0, 2).toUpperCase();
  return body.substring(0, 2).toUpperCase();
}

export function userColor(name) {
  if (!name) return '#9ca3af';
  let hash = 0;
  const s = String(name);
  for (let i = 0; i < s.length; i += 1) {
    hash = ((hash * 31) + s.charCodeAt(i)) & 0xffffff;
  }
  return _INITIAL_PALETTE[Math.abs(hash) % _INITIAL_PALETTE.length];
}

// Lexicographic comparison still gives the right answer for ISO yyyy-MM-dd
// or 'yyyy-MM-dd HH:mm' inputs. When the due string has time, compare against
// "now" with time precision; otherwise compare against today's date.
export function isOverdue(dueStr, nowOverride) {
  if (!dueStr) return false;
  const hasTime = String(dueStr).includes(' ');
  const now = nowOverride || (() => {
    const d = new Date();
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    if (!hasTime) return `${y}-${m}-${dd}`;
    const hh = String(d.getHours()).padStart(2, '0');
    const mi = String(d.getMinutes()).padStart(2, '0');
    return `${y}-${m}-${dd} ${hh}:${mi}`;
  })();
  return String(dueStr) < now;
}

// Accepts 'yyyy-MM-dd' or 'yyyy-MM-dd HH:mm'. Returns 'dd/MM' or 'dd/MM HH:mm'.
export function formatDue(dueStr) {
  if (!dueStr) return '';
  const [datePart, timePart] = String(dueStr).split(' ');
  const p = datePart.split('-');
  if (p.length !== 3) return dueStr;
  const dm = p[2] + '/' + p[1];
  return timePart ? dm + ' ' + timePart : dm;
}
